<template>
	<div class="con">
		<head-top head-title="用户登录" goBack="true"></head-top>
		<div style="padding:10% 0">
			<img :src='resourceDomain+"static/icon/logo1.png"' style="width: 40%;margin:0 auto;display:block;">
		</div>
		<van-field v-model="loginAccount" type="number" label="账号" left-icon="phone" placeholder="请输入手机号" maxlength="11"
		 clearable />
		<van-field clearable v-model="loginPassword" left-icon="lock" type="password" label="密码" maxlength="20" placeholder="请输入密码" />
		<div class="tips">
			<div class="to-register" @click="toRegitser">还没有账号？<span>去注册</span></div>
		</div>
		<div class="tipsa">
			<div class="to-register forget" @click="toForgotPassword">忘记密码?</div>
		</div>
		<div class="login_btn">
			<van-button @click="login" block type="primary">
				登 录
			</van-button>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapMutations
	} from 'vuex';
	export default {
		name: 'LoginMainAccount',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				token: '',
				loginAccount: '',
				loginPassword: '',
			}
		},
		created() {
			this.token = this.getToken()


		},
		computed: {
			...mapGetters('userModule', ['getToken'])

		},
		methods: {
			...mapMutations('userModule', ['SET_TOKEN', 'SET_MOBILE']),

			/* 登录 */
			login() {
				if (!this.loginAccount.trim()) {
					this.$toast('请输入账号')
					return
				}
				if (!this.loginPassword.trim()) {
					this.$toast('请输入密码')
					return
				}
				this.$toast.loading({
					overlay: true,
					message: '登录中...',
					duration: 0
				})
				api.post('/login', {
					loginAccount: this.loginAccount,
					loginPassword: this.loginPassword,
					loginType:1//1账号密码 2验证码
				}).then(r => {
					this.$toast.clear()
					if (r.success) {
						console.log(r)

						//清空并重置所有信息
						localStorage.clear()
						sessionStorage.clear()

						this.SET_TOKEN(r.data.token)
						this.SET_MOBILE(this.loginAccount)

						this.$router.go(-1)
					} else {
						this.$toast(r.data)
					}
					/** 
					app.getOpenid()*/
					// wx.getSetting({
					// 	success(res) {
					// 		if (res.authSetting['scope.userInfo']) {
					// 			// 已经授权，可以直接调用 getUserInfo 获取头像昵称
					// 			wx.getUserInfo({
					// 				lang:"zh_CN",
					// 				success: function (res) {
					// 					app.globalData.userInfo = res.userInfo
					// 					wx.navigateBack({
					// 						delta: 1,
					// 					})
					// 				}
					// 			})
					// 		}else{
					// 			wx.redirectTo({
					// 				url: '/pages/login/login_main/login_main?type=2',
					// 			})
					// 		}
					// 	}
					// })
				})
			},


			/**
			 * 去注册
			 */
			toRegitser: function() {
				this.$router.push({
					'path': "/login_register"
				})
			},

			/**
			 * 找回密码
			 */
			toForgotPassword() {
				this.$router.push({
					'path': "/login_forgot_password"
				})

			},

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.con {
		padding-top: 48px;
		
	}

	.tips {
		display: flex;
		justify-content: flex-end;
		font-size: 14px;
		padding-right: 20px;
		margin-top: 30px;
	}
.tipsa {
		display: flex;
		justify-content: flex-end;
		font-size: 14px;
		padding-right: 20px;
		margin-top: 10px;
	}
	button::after {
		border: 0 !important;
	}
	.login_btn{
		padding: 40px;
	}
.forget{
	padding-top:10px;
}
	.to-register {
		font-size: 14px;
		color: #089ce7;
		text-align: right;
	}
</style>
